import React from 'react';

/**
 * Handles escape key to close modal.
 */
export const createKeyDownHandler = (
  isEditorOpen: boolean,
  handleClose: () => void
): ((event: KeyboardEvent) => void) => {
  return (event: KeyboardEvent) => {
    if (event.key === 'Escape' && isEditorOpen) {
      handleClose();
    }
  };
};
